import { render, staticRenderFns } from "./InvitationMain.vue?vue&type=template&id=03ce7e98&scoped=true&"
import script from "./InvitationMain.vue?vue&type=script&lang=js&"
export * from "./InvitationMain.vue?vue&type=script&lang=js&"
import style0 from "./InvitationMain.vue?vue&type=style&index=0&id=03ce7e98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ce7e98",
  null
  
)

export default component.exports